import {
    Navigate,
    Outlet,
} from "react-router-dom";

import {
    useSelector,
} from "react-redux";

import type {
    RootState,
} from "../store";

import { getRouteForPhase } from "../utils/journeyRouting";


const PublicRoute = () => {

    const token =
        useSelector(
            (state: RootState) =>
                state.auth.token
        );

    const journey =
        useSelector(
            (state: RootState) =>
                state.journey.journey
        );


    /*
     * Already authenticated.
     *
     * Do not allow the customer to go back
     * to Login or OTP.
     */
    if (token) {

        const target = journey
            ? getRouteForPhase(journey.phase)
            : "/ndashboard";

        return (
            <Navigate
                to={target}
                replace
            />
        );
    }


    /*
     * Not authenticated and no journey.
     *
     * The customer did not enter through a valid
     * journey link (?code=...).
     *
     * Do not expose Login / OTP UI.
     */
    if (!journey) {

        return (
            <Navigate
                to="/"
                replace
            />
        );
    }


    /*
     * Unauthenticated + valid journey.
     *
     * This is the legitimate Login / OTP flow.
     */
    return <Outlet />;
};


export default PublicRoute;